module.exports = __webpack_public_path__ + "static/media/4.c41c7e80.jpg";